import { DateOfBirth, FirstName, SurName } from "./SigninFormFields";
import { dateOfBirthValidation, firstNameValidation, surNameValidation } from "./SignInFormValidation";

export const retailValidationSchema = () => firstNameValidation().concat(surNameValidation()).concat(dateOfBirthValidation())

export const RetailFieldset = () => 
  <>
    <FirstName />
    <SurName />
    <DateOfBirth />
  </>